import styles from './Terminals.module.scss';
import TerminalInfo from './TerminalInfo';
import AgencyInfo from './AgencyInfo';
import BookingInfo from './BookingInfo';
import StorageConditions from './StorageConditions';
import React, { useContext } from 'react';
import Icon from '../Icon/Icon';
import { useTranslation } from 'react-i18next';
import ModalsContext from '../../contexts/ModalsContext';
import PropTypes from 'prop-types';
import IconButton from '../Button/IconButton';

const TerminalInfoModelHeadline = ({ icon, terminalName, modelName }) => {
    const computedIcon = icon ? React.createElement(Icon[icon]) : null;

    return (
        <div className={styles.InfoSectionHeadline}>
            {computedIcon}
            <div>
                {modelName}: {terminalName}
            </div>
        </div>
    );
};
const TableActionButtons = ({ terminal, visibleInfo }) => {
    const { t } = useTranslation();
    const { showModal } = useContext(ModalsContext);

    return (
        <div className={styles.Last}>
            {visibleInfo?.terminal_info && (
                <IconButton
                    icon='terminal'
                    tooltip={t('terminals.terminalInfo')}
                    onClick={() =>
                        showModal(
                            <TerminalInfoModelHeadline
                                icon='terminal'
                                terminalName={terminal.name}
                                modelName={t('terminals.terminalInfo')}
                            />,
                            <TerminalInfo
                                terminalInfo={{
                                    name: terminal.name,
                                    facilityInfo: terminal.facilityInfo,
                                    ...terminal.info,
                                }}
                            />,
                            'back'
                        )
                    }
                />
            )}
            {visibleInfo?.agency_info && (
                <IconButton
                    icon='agency'
                    tooltip={t('terminals.agencyInfo')}
                    onClick={() =>
                        showModal(
                            <TerminalInfoModelHeadline
                                icon='agency'
                                terminalName={terminal.name}
                                modelName={t('terminals.agencyInfo')}
                            />,
                            <AgencyInfo agencyInfo={terminal.agency} />,
                            'back'
                        )
                    }
                />
            )}
            {visibleInfo?.booking_info && (
                <IconButton
                    icon='booking'
                    tooltip={t('terminals.bookingInfo')}
                    onClick={() =>
                        showModal(
                            <TerminalInfoModelHeadline
                                icon='booking'
                                terminalName={terminal.name}
                                modelName={t('terminals.bookingInfo')}
                            />,
                            <BookingInfo
                                bookingInfo={[
                                    terminal.primaryBookingOffice,
                                    terminal.secondaryBookingOffice,
                                ]}
                            />,
                            'back'
                        )
                    }
                />
            )}
            {visibleInfo?.parking_fees && (
                <IconButton
                    icon='euro-symbol'
                    tooltip={t('terminals.storageConditions')}
                    onClick={() =>
                        showModal(
                            <TerminalInfoModelHeadline
                                icon='euro-symbol'
                                terminalName={terminal.name}
                                modelName={t('terminals.storageConditions')}
                            />,
                            <StorageConditions hafasId={terminal.hafasId} />,
                            'back',
                            'extra-wide'
                        )
                    }
                />
            )}
        </div>
    );
};

TableActionButtons.propTypes = {
    terminal: PropTypes.shape({
        name: PropTypes.string.isRequired,
        info: PropTypes.object,
        agency: PropTypes.object,
        primaryBookingOffice: PropTypes.object,
        secondaryBookingOffice: PropTypes.object,
        hafasId: PropTypes.string,
        facilityInfo: PropTypes.object,
    }).isRequired,
    visibleInfo: PropTypes.shape({
        terminal_info: PropTypes.bool,
        agency_info: PropTypes.bool,
        booking_info: PropTypes.bool,
        parking_fees: PropTypes.bool,
    }),
};

export default TableActionButtons;
